export const MOCK_RESPONSE_POST_EMPLOYER_CREDITS = {
  totalAvailableCredits: 1,
  monthlyCredits: 5,
  consumedCredits: 1,
  totalCredits: 1000,
  trend: {
    creditsConsumed: 2,
    creditsConsumedMonthly: 3,
    progress: 40,
  },
  items: [
    {
      accumulatedCredits: 0,
      receivedCredits: 1,
      residualCredits: 4,
      spentCredits: 0,
    },
  ],
};

export const MOCK_RESPONSE_POST_EMPLOYER_CREDITS_SUMMARY_BY_CATEGORY = {
  income: [
    {
      eventType: 'string',
      credits: 100,
    },
  ],
  spent: [
    {
      eventType: 'string',
      credits: 100,
    },
  ],
};

export const MOCK_RESPONSE_POST_EMPLOYER_CREDITS_HISTORY = {
  totalItems: 1,
  data: [
    {
      id: '1',
      credits: 10,
      details: 'string',
      timestamp: '2023-10-10T10:00:00Z',
      contentId: '1',
      eventType: 'SURVEY' as const,
      performedBy: 'SYSTEM' as const,
    },
  ],
};

export const MOCK_RESPONSE_GET_EMPLOYER_CREDITS_HISTORY = {
  totalItems: 1,
  data: [
    {
      id: '1',
      credits: 10,
      details: 'string',
      timestamp: '2023-10-10T10:00:00Z',
      contentId: '1',
      eventType: 'SURVEY' as const,
      performedBy: 'SYSTEM' as const,
    },
  ],
};

export const MOCK_RESPONSE_GET_EMPLOYER_CREDITS = {
  monthlyCredits: 12,
  consumedCredits: 12,
  totalAvailableCredits: 1000,
  totalCredits: 1000,
};
